import React, { useContext } from 'react';
import * as Yup from 'yup';
import {
  MasterDetailForm,
  CrudContext,
  FormSubmitButton,
  FormatText,
  Widget,
  FormInput,
  FormSelect,
  FormDatePicker,
  usePromise,
  FormNumber,
} from '@digital/ui';

import ComponeteCurso from '../../components/componeteCurso';
import { getAllPerfilMrnOptions } from '@app/api/PerfilAcesso';

const CreateUserForm = (props: any) => {
  return (
    <>
      <MasterDetailForm
        initialValues={{ tipoUsuario: 'Terceiro' }}
        validationSchema={Yup.object().shape({
          username: Yup.string()
            .required('Username deve ser informado')
            .max(20, 'O Username deve ter no máximo 20 caracteres.'),
          nome: Yup.string().required('Nome deve ser informado').max(100, 'O nome deve ter no máximo 100 caracteres.'),
          email: Yup.string()
            .required('E-mail deve ser informado')
            .email('Informe um endereço de e-mail válido')
            .max(100, 'O e-mail deve ter no máximo 100 caracteres.'),
          cargo: Yup.string().required('Cargo deve ser informado').max(50, 'O cargo deve ter no máximo 50 caracteres.'),
          telefone1: Yup.string()
            .required('Telefone deve ser informado')
            .max(20, 'O telefone deve ter no máximo 20 caracteres.'),
          perfis: Yup.string().required('Ao menos um perfil deve ser informado'),
        })}>
        <Widget
          title="Cadastro de Usuário de Terceiros"
          actions={[
            <FormSubmitButton noIcon={true} type="primary">
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <FormInput label="Username" name="username" span={6} />
          <FormInput label="Nome" name="nome" span={6} />
          <FormInput label="E-mail" name="email" span={6} />
          <FormInput label="Cargo" name="cargo" span={6} />
          <FormInput label="Telefone 1" name="telefone1" span={6} />
          <FormInput label="Telefone 2" name="telefone2" span={6} />
          <fieldset>
            <legend>Tipos de Usuários</legend>
            <FormInput label="Tipo de Usuário" name="tipoUsuario" disabled span={6} />
          </fieldset>
          <fieldset>
            <legend>Pré-Contratação</legend>
            <FormNumber label="Nº processos paralelos" name="processosParalelos" span={6} />
          </fieldset>
          <fieldset>
            <legend>Perfil</legend>
            <FormSelect
              showSearch
              mode="multiple"
              label="Perfis"
              name="perfis"
              getOptions={getAllPerfilMrnOptions}
              span={12}
              optionFilterProp="children"
              filterOption={(input, item) => {
                return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
              }}
            />
          </fieldset>

          {/* <ComponeteCurso
            id={''}
            nomeIdFormulario={'CartaDeNomeacaoGestordoContrato'}
            enderecoApi={'contratos/updateArquivoContratoAditivos'}
            descricaoBotao={'Carta de nomeação de Gestor do Contrato'}
            retorno={data => {
              if (data.valid) {

              }
            }}
            idDoComponente={'CartaDeNomeacaoGestordoContrato'}
          /> */}
        </Widget>
      </MasterDetailForm>
    </>
  );
};

export default CreateUserForm;
